'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fCSVReportsService = function fCSVReportsService($window) {
	_classCallCheck(this, fCSVReportsService);

	function _createTempAnchor(href, download) {
		// Create a temporary DOM element
		var anchor = angular.element('<a/>');

		anchor.css({ display: 'none' }); // Make sure it's not visible
		angular.element(document.body).append(anchor); // Attach to document

		if (download) anchor.attr({ download: download });

		anchor.attr({
			href: href,
			target: '_blank'
		})[0].click(); // Trigger download

		anchor.remove(); // Clean it up afterwards
	}

	function convertToCSV(objArray) {
		var array = (typeof objArray === 'undefined' ? 'undefined' : _typeof(objArray)) != 'object' ? JSON.parse(objArray) : objArray;
		var str = '';

		for (var i = 0; i < array.length; i++) {
			var line = '';
			for (var index in array[i]) {
				if (line != '') line += ',';
				line += JSON.stringify(array[i][index]);
			}
			str += line + '\r\n';
		}

		return str;
	}

	function prepareCSV(arr, filename) {
		// Convert to CSV
		var json = JSON.stringify(arr);
		var csv1 = convertToCSV(json);

		// Prepare file
		var blob = new Blob([csv1], { type: 'text/csv' }),
		    url = $window.URL.createObjectURL(blob);

		_createTempAnchor(url, filename || 'ifeis.csv');
	}

	return {
		convertToCSV: convertToCSV,
		prepareCSV: prepareCSV
	};
};

exports.default = angular.module('ifeis.csv', []).service('fCSVReportsService', fCSVReportsService);


//////////////////
// WEBPACK FOOTER
// ./reports-csv/index.js
// module id = 216
// module chunks = 0